import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { FormAPI, ContactForm } from '../../api/formApi';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const contactData: ContactForm = {
        email: email.trim(),
        name: 'Подписчик на рассылку'
      };

      await FormAPI.submitContact(contactData);
      setSubmitStatus('success');
      setEmail('');
    } catch (error) {
      console.error('Ошибка отправки email:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="w-full bg-gray-800 text-white">
      {/* Блок 1: Лого, предложения, инпут и текст */}
      <div className="border-b border-gray-700">
        <div className="mx-auto max-w-container px-4 py-4 md:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
            <div className="flex items-center gap-4 md:gap-6">
              <div className="text-xl md:text-2xl font-bold text-white">parallel</div>
            </div>
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 w-full md:w-auto">
              <p className="text-white text-xs md:text-sm text-center md:text-left">
                Получайте эксклюзивные<br/>предложения и скидки
              </p>
              <form onSubmit={handleEmailSubmit} className="flex flex-col gap-2 w-full md:w-auto">
                <div className="relative">
                  <input 
                    type="email" 
                    placeholder="Введите e-mail" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isSubmitting}
                    className="w-full px-4 py-2 pr-12 bg-gray-700 border border-gray-600 rounded-full text-white placeholder-gray-400 focus:outline-none focus:border-red-500 disabled:opacity-50"
                    required
                  />
                  <button 
                    type="submit"
                    disabled={isSubmitting || !email.trim()}
                    className="absolute right-1 top-1 w-8 h-8 bg-red-600 hover:bg-red-700 disabled:bg-gray-500 rounded-full flex items-center justify-center transition-colors"
                  >
                    {isSubmitting ? (
                      <div className="w-3 h-3 border border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <span className="text-white text-sm">→</span>
                    )}
                  </button>
                </div>
                {submitStatus === 'success' && (
                  <p className="text-xs text-green-400 pl-4">Спасибо за подписку!</p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-xs text-red-400 pl-4">Ошибка отправки. Попробуйте еще раз.</p>
                )}
                <p className="text-xs text-white pl-4">
                  Подписываясь на рассылку, вы соглашаетесь с условиями{' '}
                  <span className="text-red-500 cursor-pointer hover:underline">оферты</span> и{' '}
                  <span className="text-red-500 cursor-pointer hover:underline">политики конфиденциальности</span>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Блок 2: Основной контент */}
      <div className="mx-auto max-w-container px-4 py-6 md:py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6 md:gap-8">
          {/* Контакты */}
          <div className="text-white">
            <h3 className="text-base md:text-lg font-semibold mb-3 md:mb-4">Контакты</h3>
            <div className="text-xs md:text-sm text-white">
              <p className="font-light text-white mb-2">Санкт-Петербург,<br/> ул. Школьная, дом 37</p>
              <p className="font-light text-white mb-2">+7 (812) 714-81-48</p>
              <p className="font-light text-white mb-3 md:mb-0">req@parallel.one</p>  
              <div className="flex gap-2 mt-3 md:mt-4">
                <div className="w-6 h-6 md:w-8 md:h-8 border-2 border-red-600 bg-red-600 rounded-full"></div>
                <div className="w-6 h-6 md:w-8 md:h-8 border-2 border-red-600 bg-red-600 rounded-full"></div>
                <div className="w-6 h-6 md:w-8 md:h-8 border-2 border-red-600 bg-red-600 rounded-full"></div>
                <div className="w-6 h-6 md:w-8 md:h-8 border-2 border-red-600 bg-red-600 rounded-full"></div>
                <div className="w-6 h-6 md:w-8 md:h-8 border-2 border-red-600 bg-red-600 rounded-full"></div>
              </div>
            </div>
          </div>

          {/* Каталог */}
          <div className="space-y-4">

          </div>

          {/* Параллель */}
          <div className="space-y-4">

          </div>

          {/* Помощь */}
          <div className="space-y-3 md:space-y-4">
            <h3 className="text-base md:text-lg font-semibold">Помощь</h3>
            <div className="space-y-2 text-xs md:text-sm">
              <Link to="/delivery" className="block hover:text-gray-300 transition-colors">Доставка заказа</Link>
              <Link to="/returns" className="block hover:text-gray-300 transition-colors">Возврат товара</Link>
            </div>
          </div>

          {/* Клиентский сервис */}
          <div className="space-y-3 md:space-y-4">
            <h3 className="text-base md:text-lg font-semibold">Клиентский сервис</h3>
            <div className="space-y-2 text-xs md:text-sm">
              <Link to="/privacy" className="block hover:text-gray-300 transition-colors">Политика конфиденциальности</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Блок 3: 2025 parallel © */}
      <div className="border-t border-gray-700">
        <div className="mx-auto max-w-container px-4 py-3 md:py-4">
          <p className="text-xs md:text-sm font-light text-white">2025 parallel ©</p>
        </div>
      </div>

      {/* Блок 4: Длинный текст с рейтингом */}
      <div className="border-t border-gray-700">
        <div className="mx-auto max-w-container px-4 py-3 md:py-4">
          <div className="flex flex-col md:flex-row justify-between items-start gap-3 md:gap-4">
            <div className="flex-1">
              <p className="text-[10px] md:text-xs font-light text-white/50 leading-relaxed">
                Технические характеристики товаров могут отличаться от указанных на сайте. 
                Производитель оставляет за собой право изменять комплектацию и внешний вид товара без предварительного уведомления. 
                Изображения товаров на сайте носят информационный характер и могут отличаться от оригинала. 
                Цены, указанные на сайте, не являются публичной офертой. 
                Актуальные цены уточняйте у менеджеров. 
                Все товары сертифицированы и имеют гарантию производителя.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;